import { render } from "./BomValidationResultsElementsAmbiguousOldVersion.vue?vue&type=template&id=5a0c5704&scoped=true"
import script from "./BomValidationResultsElementsAmbiguousOldVersion.vue?vue&type=script&lang=js"
export * from "./BomValidationResultsElementsAmbiguousOldVersion.vue?vue&type=script&lang=js"

import "./BomValidationResultsElementsAmbiguousOldVersion.vue?vue&type=style&index=0&id=5a0c5704&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0c5704"]])

export default __exports__